import { activityHistoryFiltersSlice } from "../../slice";

export const { setCommonFilterValue } = activityHistoryFiltersSlice.actions;
